var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(_vm._s(_vm.numShipped)+" of "+_vm._s(_vm.numOrdered)+" "+_vm._s((_vm.numOrdered === 1) ? 'Item' : 'Items'))])
}
var staticRenderFns = []

export { render, staticRenderFns }